import * as React from 'react'
import PropTypes from 'prop-types'

import { eventHandlers, EventListenerTypes } from './eventTypes'

interface StopPropagationProps {
  /**
   * Nodes of any kind.
   */
  children?: React.ReactNode
  /**
   * An array of React event handlers that will be propagated up through the DOM
   */
  ignoreEvents?: Array<keyof EventListenerTypes>
}

/**
 * StopPropagation is a component that stops event propation up the DOM tree. It uses the React event paradigm (onClick, onMouseEnter, etc...)
 */
export function StopPropagation({
  children,
  ignoreEvents,
}: StopPropagationProps) {
  const eventsToPropagate: EventListenerTypes = {}

  ignoreEvents?.forEach((arrayItem) => {
    eventsToPropagate[arrayItem] = () => null
  })

  return (
    <div {...eventHandlers} {...eventsToPropagate}>
      {children}
    </div>
  )
}

StopPropagation.propTypes = {
  children: PropTypes.node,
  ignoreEvents: PropTypes.arrayOf(PropTypes.string),
}

export default StopPropagation
